import BackendAPI from '../../../core/static/js/helpers/API.js'
import { setCookie, getCookie } from '../../../core/static/js/helpers/utils.js'

export default class ProductNav extends HTMLElement {
  constructor() {
    super();

    this.API = new BackendAPI();
    this.API.setBaseUrl(host);
    this._type = '';
    this._swatches = ''
    this._shippingInfo = JSON.parse(this.getAttribute('shippingInfo'));
    this.images = JSON.parse(this.getAttribute('images'));
    this.detailsComponent = {};
    this.currentGroup = '';
    this.urlSlug = '';
    // set default style to men
    this._style = shop_url.style;
    this._variant = shop_url.variant;
    this._styles = [];
    this._renderPack = this.getAttribute('renderPack');
    this._clubbedProducts = JSON.parse(this.getAttribute('clubbedProducts'));
    const typeInfoAttr = this.getAttribute('typeInfo');
    this._typeInfo = typeInfoAttr ? JSON.parse(typeInfoAttr) : {};
    this._features = this._typeInfo.features || '';
    this.sizeGuideComponent = {};

  }

  get type() {
    return this._type;
  }
  set type(val) {
    this._type = val;
  }
  get variant() {
    return this._variant;
  }
  set variant(val) {
    this._variant = val;
  }

  get style() {
    return this._style;
  }
  set style(val) {
    this._style = val;
    this.renderSwatches();

    // if style changes then select first swatch of that style by default 
    const swatches = document.querySelectorAll(".swatches a.swatch");
    if (swatches && swatches.length > 0){
      swatches[0].classList.add("selected");
      let url = swatches[0].getAttribute('data-url');
      window.location.href = url;
      //swatches[0].dispatchEvent(new CustomEvent('click'));
    }
    if (this.detailsComponent){
      this.detailsComponent.style = val;
    }
  }

  get styles() {
    return this._styles;
  }
  set styles(val) {
    this._styles = val;
  }

  get swatches() {
    return this._swatches;
  }
  set swatches(val) {
    this._swatches = val;
  }

  get shippingInfo() {
    return this._shippingInfo;
  }

  get swatchStore() {
    return this._swatchStore;
  }
  set swatchStore(val) {
    this._swatchStore = val;
  }


  get renderPack(){
    this._renderPack;
  }

  get clubbedProducts(){
    return this._clubbedProducts;
  }

  get typeInfo(){
    return this._typeInfo;
  }

  get features(){
    return this._features;
  }

  connectedCallback() {


    window.addEventListener('popstate', (event) => {
      let pathName = window.location.pathname;
      let urlFromSwatchStore = this.swatchStore[pathName];
      if (urlFromSwatchStore) {
        this.updateProductDetailsWithURL(urlFromSwatchStore);
        nav.dispatchEvent(new CustomEvent("SwatchClick", {
          detail: { link: document.querySelector(`a[data-url='${pathName}']`), e: event, storeState: false }
        }));
      }
    });

    this.type = this.getAttribute('type');
    this.swatches = JSON.parse(this.getAttribute('swatches'));
    this.styles = JSON.parse(this.getAttribute('styles'));
    this.updateSwatchStore(this.swatches);
    this.renderTemplate();
    this.renderSwatches();
    this.detailsComponent = document.querySelector('product-details');
    this.productCarousel = document.querySelector('product-carousel');
    this.featuresComponent = document.querySelector('product-features');
    this.storiesComponent = document.querySelector('product-stories');

    // Web component to render special hero features block
    this.specialHeroFeatures = document.querySelector('special-hero-features');
    let nav = this;

    //Toggle product overview, features, stories and details blocks
    //This needs to go since we are not toggling between the features and product pages
    const navLinks = document.querySelectorAll(".product-nav > .info > a.jump-link, .product-nav > .info > .section-link");
    for (let i = 0; i < navLinks.length; i++) {
      navLinks[i].addEventListener('click', (event) => {
        event.preventDefault();
        if (nav.detailsComponent) {
          nav.detailsComponent.style.display = 'none';
        }
        let dataUrl = event.target.getAttribute('data-url');
        if (dataUrl){
          window.location.href = dataUrl;
        }
      });
    }
    const styleSelector = this.querySelector('nav.info select.styles');
    if (styleSelector){
      styleSelector.addEventListener('change', (event) => {
        let selectedStyle = event.target.selectedOptions[0];
        this.style = selectedStyle.value;
        setCookie('style', this.style);
      });
    }

    // After rendering the template and appending to DOM
    const swatchList = this.querySelector('product-swatch-list');
    if (swatchList) {
      swatchList.swatches = this.swatches;         // Pass as array
      swatchList.currentStyle = this.style;        // Pass as string
      swatchList.clubbedProducts = this.clubbedProducts; // Pass clubbed products
      swatchList.shop_url = this.shop_url;
    }

    // Centralized SwatchClick event handler
    this.addEventListener('SwatchListClick', (event) => {
      const { link, e, storeState } = event.detail;
      // Remove selected class from all swatches first
      const allSwatches = document.querySelectorAll(".swatches a.swatch, .packswatches .colours-packs .grid a.cp-option");
      allSwatches.forEach(swatch => swatch.classList.remove('selected'));

      // Remove selected class from all swatch-links in product-swatch-list
      const swatchListLinks = document.querySelectorAll('product-swatch-list .swatch-link');
      swatchListLinks.forEach(swatchLink => swatchLink.classList.remove('selected'));
      
      // Add selected class to clicked swatch
      link.classList.add('selected');
      
      if (storeState) {
        const url = link.getAttribute('data-url');
        if (url) {
          window.history.pushState({ page: url }, '', url);
        }
      }

      const filteredSwatch = Array.from(allSwatches).filter(swatch => swatch.getAttribute('data-url') === link.getAttribute('data-url'));
      const nav = this;
      nav.dispatchEvent(new CustomEvent("SwatchClick", {
        detail: { link: filteredSwatch[0], e: e, storeState: false }
      }));
      if (!nav.detailsComponent) {
        nav.detailsComponent = document.createElement('product-details')
        document.querySelector('main').appendChild(nav.detailsComponent);
      }
      this.updateProductDetails(link);
      this.saveProductData(this.type, this.style);
      
    });

    // Handle ClubbedProductClick event
    this.addEventListener('ClubbedProductClick', (event) => {
      const { link, e, storeState } = event.detail;
      
      if (!link) {
        return;
      }

      // Get the URL from the clicked link
      const url = link.getAttribute('data-url');
      
      if (url) {
        // Navigate to the clubbed product's URL
        window.location.href = url;
      } else {
        console.error('No URL found in link');
      }
    });
  }

  initSwatchClick() {
    const swatches = document.querySelectorAll(".swatches a.swatch");
    const nav = this;
    if (swatches.length > 0){
        for (let i = 0; i < swatches.length; i++) {
        swatches[i].addEventListener('click', (event) => {
          event.preventDefault();
          nav.dispatchEvent(new CustomEvent("SwatchClick", {
            detail: { link: swatches[i], e: event, storeState: true }
          }));

          if (!nav.detailsComponent) {
            nav.detailsComponent = document.createElement('product-details')
            document.querySelector('main').appendChild(nav.detailsComponent);
          }
          nav.updateProductDetails(swatches[i]);
          nav.saveProductData(nav.type, nav.style);
        })
      }
    }
  }

  initPackSwatchClick() {
    const swatches = document.querySelectorAll(".packswatches .colours-packs .grid a.cp-option");
    const nav = this;
    if (swatches.length > 0){
        for (let i = 0; i < swatches.length; i++) {
        swatches[i].addEventListener('click', (event) => {
          event.preventDefault();
          nav.dispatchEvent(new CustomEvent("SwatchClick", {
            detail: { link: swatches[i], e: event, storeState: true }
          }));

          if (!nav.detailsComponent) {
            nav.detailsComponent = document.createElement('product-details')
            document.querySelector('main').appendChild(nav.detailsComponent);
          }
          nav.updateProductDetails(swatches[i]);
          nav.saveProductData(nav.type, nav.style);
        })
      }
    }
  }

  //Update product details
  updateProductDetails(swatch) {
    this.currentGroup = swatch.getAttribute('data-group');
    this.urlSlug = swatch.getAttribute('data-urlSlug');
    this.getProducts()
      .then((data) => {
        this.detailsComponent.group = data.group_info;
        this.detailsComponent.offerText = data.offerText;
        this.detailsComponent.shippingInfo = this.shippingInfo;
        this.detailsComponent.sizeGuideInfo = data.metrology_info;
        this.detailsComponent.products = data.products;
        this.detailsComponent.currentStyle = this.style;
        this.detailsComponent.style.display = 'block';
        this.detailsComponent.sizeGuideUrl = data.sizeGuideUrl;
        this.productCarousel.style = this.style;
        this.productCarousel.type = this.type;
        this.productCarousel.group = data.group_info;

        if(this.specialHeroFeatures != null){
          this.specialHeroFeatures.productStyle = this.style;
          this.specialHeroFeatures.type = this.type;
          this.specialHeroFeatures.group = data.group_info;
        }
        // dynamic review and review text
        let reviewsBlock = document.querySelector('.product .reviews-block');
        if (reviewsBlock){
          let reviewText = reviewsBlock.querySelector('.review');
          let reviewer = reviewsBlock.querySelector('.reviewer');
          if (reviewText){
            reviewText.textContent = data.group_info.review_text;
          }
          if (reviewer){
              reviewer.textContent = data.group_info.reviewer;
          }
        }

        // Sets the Safari MacOS Bar to the selected products color WHAT!:)
        // Not using it now. Its a bit lud, so perhaps later.
        
        // let selectedProductColor = swatch.firstElementChild.style.backgroundColor;
        // document.getElementsByTagName('head')[0].lastElementChild.content = selectedProductColor;
      })
      .catch((error) => {
        console.log(error)
      });
  }

  //Update product details
  updateProductDetailsWithURL(swatch) {
    this.currentGroup = swatch['group'];
    this.urlSlug = swatch['url_slug'];
    this.getProducts()
      .then((data) => {
        this.detailsComponent.group = data.group_info;
        this.detailsComponent.offerText = data.offerText;
        this.detailsComponent.shippingInfo = this.shippingInfo;
        this.detailsComponent.sizeGuideInfo = data.metrology_info;
        this.detailsComponent.products = data.products;
        this.detailsComponent.currentStyle = this.style;
        this.detailsComponent.style.display = 'block';
        this.detailsComponent.sizeGuideUrl = data.sizeGuideUrl;
        this.productCarousel.style = this.style;
        this.productCarousel.type = this.type;
        this.productCarousel.group = data.group_info;

        if(this.specialHeroFeatures != null){
          this.specialHeroFeatures.productStyle = this.style;
          this.specialHeroFeatures.type = this.type;
          this.specialHeroFeatures.group = data.group_info;
        }
        // dynamic review and review text
        let reviewsBlock = document.querySelector('.product .reviews-block');
        if (reviewsBlock){
          let reviewText = reviewsBlock.querySelector('.review');
          let reviewer = reviewsBlock.querySelector('.reviewer');
          if (reviewText){
            reviewText.textContent = data.group_info.review_text;
          }
          if (reviewer){
              reviewer.textContent = data.group_info.reviewer;
          }
        }

        // Sets the Safari MacOS Bar to the selected products color WHAT!:)
        // Not using it now. Its a bit lud, so perhaps later.
        
        // let selectedProductColor = swatch.firstElementChild.style.backgroundColor;
        // document.getElementsByTagName('head')[0].lastElementChild.content = selectedProductColor;
      })
      .catch((error) => {
        console.log(error)
      });
  }
  saveProductData(type, style){
    // push or update type,style to cookies here
    let productData = getCookie('product_data');
    if (productData){
        let productDataList= JSON.parse(productData);
        if (productDataList && productDataList.length > 0){

          let product = productDataList.find(function(p){
              if (p.hasOwnProperty(type)){
                 return p;
              }
          });
          if (product){
                if (!product[type].hasOwnProperty(style)){
                  product[type][style] = null;
                  setCookie('product_data', JSON.stringify(productDataList), 10*365);
                } 
          }
          else{
            productDataList.push({[type]:{[style]:null}})
            setCookie('product_data', JSON.stringify(productDataList), 10*365);
          }
        }
    }
    else{
      productData = [];
      let product = {[type]:{[style]:null}}
      productData.push(product)
      setCookie('product_data', JSON.stringify(productData), 10*365);
    }
  }

  getProducts() {
    return new Promise((resolve, reject) => {
      var url = `/products/${this.type}/${this.style}/${this.urlSlug}/${this.variant}`;
      
      this.API.get(url)
        .then(data => {
          resolve(data);
          const images = this.images[this.style][data.group_info.id];
          if (!images) {
            return;
          }
          // Find the wrapper
          const wrapper = this.querySelector('.size-guide-wrapper');
          if (wrapper) {
            // Remove existing size-guide if it exists
            const existingSizeGuide = wrapper.querySelector('size-guide');
            if (existingSizeGuide) {
              existingSizeGuide.remove();
            }

            // Create and attach new size-guide element with data
            const sizeGuide = document.createElement('size-guide');
            sizeGuide.productData = data;
            sizeGuide.setAttribute('products', JSON.stringify(data.products));
            sizeGuide.setAttribute('avatarinfo', JSON.stringify(data.size_guide_info));
            wrapper.appendChild(sizeGuide);
          }
        }).catch(error => {
          reject(error)
        });
    })
  }

  disconnectedCallback() {
  }

  renderTemplate() {
    let shopUrl = '';
    if (this.type == 'unit') {
      shopUrl = `/unitpq`;
    }
    else if (this.type == 'unitfl') {
      shopUrl = `#`;
    }
    else {
      shopUrl = `/${this.type}`;
    }

    const productNavTemplate = document.createElement('template');
    productNavTemplate.innerHTML = `<div class="product-nav-wrapper" id="productNav">
      <div class="container-fluid">
        <div class="row">
          <div class="col-md-10 col-md-offset-1 col-xs-12">
            <div class="product-nav">
              <nav class="info">
                ${this.clubbedProducts.categories && this.clubbedProducts.categories.length > 1 ? `
                <div class="slider render-this-block-if-cc">
                  <div class="category-picker">
                      ${this.clubbedProducts.categories 
                        ? this.clubbedProducts.categories.map(category => {
                            return `<a class="category button button-medium rounded ${category.category == this.type ? 'selected' : ''}" 
                                      href="${category.shop_url}">
                                      ${category.name}
                                    </a>`;
                          }).join('') 
                        : ''}
                  </div>
                </div>
                ` : ''}
                ${this.clubbedProducts.categories && this.clubbedProducts.categories.length === 1 ? `<p class="footnote title render-this-block-if-nocc">${this.clubbedProducts.categories[0].name}</p>` : ''}
              </nav>
              <nav class="swatches">
              </nav>
            </div>
          </div>
        </div>
      </div>
    </div>
    ${this.features ? `
    <div class="container-fluid">
        <div class="row">
          <div class="col-md-10 col-md-offset-1 col-xs-12">
            <div class="feature-marquee">
              <div class="marquee">
                <p class="footnote title">${this.features}</p>
                <p class="footnote title">${this.features}</p>
              </div>
            </div>
          </div>
        </div>
    </div>
    ` : ''}
    <nav class="packswatches">
      <div class="container-fluid">
          <div class="row">
            <div class="col-md-10 col-md-offset-1 col-xs-12">
              <div class="colours-packs">
                <p class="footnote title">Colours &amp; Packs</p>
                <div class="grid">
                </div>
              </div>
            </div> 
        </div>
      </div>
    </nav>
    <div class="size-guide-wrapper">
    </div>
    <product-swatch-list></product-swatch-list>
    `;
    this.appendChild(productNavTemplate.content.cloneNode(true));
  }

  renderPackSwatches() {
    let swatchEle = this.querySelector('.packswatches .colours-packs .grid');
        let detailsBlock = document.querySelector('.product-variant #details');
        swatchEle.innerHTML = "";
        let counter = 0;
        for (const swatch of this.swatches) {
          if (swatch.style != this.style){
            continue;
          }
          counter++;
          var a = document.createElement("a");
          a.setAttribute('class', 'cp-option');
          if (counter === 1) {
            a.classList.add("selected")
          }
          a.classList.add("cp-option");
          if ( swatch.productcolor_thumbnails.length > 3 ){
            a.classList.add("threshold");
          }
          a.setAttribute('href', '#');
          a.setAttribute('data-group', swatch.group);
          a.setAttribute('data-urlSlug', swatch.url_slug);
          a.setAttribute('data-url', swatch.shop_url);
          a.setAttribute('rel', 'prefetch');
          let imagesHTML = '';
          for (let i = 0; i < swatch.productcolor_thumbnails.length; i++) {
            imagesHTML += `<div class="thumbnail"><img src="${swatch.productcolor_thumbnails[i]}" /></div>`;
          }
          let is_pack = swatch.is_pack
          let subnames = swatch.pack_subnames
          let subNamesHTML = ''
          if(is_pack ==true && subnames.length > 0){
            subNamesHTML = subnames.join(' · ');
          }
          a.innerHTML = `
            <div class="info">
              <p class="footnote">${swatch.name}</p>
              <p class="footnote subtle">${subNamesHTML}</p>
            </div>
            <div class="thumbnails">
              ${imagesHTML}
            </div>
          `;



          swatchEle.appendChild(a);
          if (this.swatches.length && this.swatches.length === 1) {
            swatchEle.style.display = 'none';
          } else if (this.swatches.length && this.swatches.length === 2 && this.swatches[0].style != this.swatches[1].style) {
            swatchEle.style.display = 'none';
          }
        }
        swatchEle.innerHTML += '<div class="more-colours"></div>';
        let swatches = swatchEle.querySelectorAll('a.cp-option');
        // show single swatch on shop page except for lint roller
        if (swatches && swatches.length == 1 && (this.type == 'lintroller' || this.type == 'lintroller-refill')){
            swatches[0].style.display = 'none';
        }
        this.initPackSwatchClick();
  }

  renderGroupSwatches() {
    let swatchEle = this.querySelector('#productNav .swatches');
    
    // Clear existing swatches
    if (swatchEle) {
      swatchEle.innerHTML = '';
    } else {
      console.error('Swatch element not found!');
      return;
    }

    if(this.type == 'one-offs'){
      // Hide
      swatchEle.innerHTML = '';
      return;
    }
    
    let detailsBlock = document.querySelector('.product-variant #details');
    const MAX_DISPLAYED_SWATCHES = 10;

    // Filter swatches by current style
    let availableSwatches = this.swatches.filter(swatch => swatch.style === this.style);
    
    // Separate sale and non-sale swatches
    let nonSaleSwatches = availableSwatches.filter(swatch => 
      !(swatch.is_sale_product || swatch.is_sale_product == true || swatch.is_sale_product === "true")
    );
    
    let saleSwatches = availableSwatches.filter(swatch => 
      swatch.is_sale_product || swatch.is_sale_product == true || swatch.is_sale_product === "true"
    );
    
    // Get clubbed products if they exist
    let nonSaleClubbedProducts = [];
    let saleClubbedProducts = [];
    
    if (this.clubbedProducts && 
        typeof this.clubbedProducts === 'object' && 
        !Array.isArray(this.clubbedProducts) && 
        this.clubbedProducts.products && 
        this.clubbedProducts.products.length > 0) {
          
      // Filter clubbed products by style and separate sale/non-sale
      const clubbedByStyle = this.clubbedProducts.products.filter(product => product.style === this.style);
      
      nonSaleClubbedProducts = clubbedByStyle.filter(product => 
        !(product.is_sale_product || product.is_sale_product == true || product.is_sale_product === "true")
      );
      
      saleClubbedProducts = clubbedByStyle.filter(product => 
        product.is_sale_product || product.is_sale_product == true || product.is_sale_product === "true"
      );
    }
    
    // Create the complete ordered list first (for swatch list)
    const completeOrderedList = [
      ...nonSaleSwatches,
      // ...nonSaleClubbedProducts, 
      ...saleSwatches,
      // ...saleClubbedProducts
    ];

    // Create a filtered list WITHOUT clubbed products for main nav display
    const navDisplayList = [
      ...nonSaleSwatches,
      ...saleSwatches
    ];

    // Now slice from the nav display list (without clubbed products)
    const displayedSwatches = navDisplayList.slice(0, MAX_DISPLAYED_SWATCHES);
    const displayedSwatchCount = displayedSwatches.length;

    // Render the main display swatches (only regular swatches, no clubbed)
    for (let i = 0; i < displayedSwatches.length; i++) {
      const item = displayedSwatches[i];
      
      // Create regular swatch (no need to check for clubbed since we filtered them out)
      var a = document.createElement("a");
      a.setAttribute('class', 'swatch');
      if (i === 0) {
        a.classList.add("selected");
      }
      a.setAttribute('href', '#');
      a.setAttribute('data-group', item.group);
      a.setAttribute('data-urlSlug', item.url_slug);
      a.setAttribute('data-url', item.shop_url);
      a.setAttribute('rel', 'prefetch');
      a.innerHTML = `<span style="background-color: ${item.productcolor}">`;
      
      swatchEle.appendChild(a);
    }

    // Add "more" button based on complete list (including clubbed products)
    const totalSwatches = completeOrderedList.length;
    const remainingSwatchesCount = totalSwatches - displayedSwatchCount;

    if (remainingSwatchesCount > 0) {
      swatchEle.innerHTML += `<a class="more-colours button button-medium rounded">+${remainingSwatchesCount}</a>`;
    }
    
    // Handle special cases
    let swatches = swatchEle.querySelectorAll('a.swatch');
    if (swatches && swatches.length == 1 && (this.type == 'lintroller' || this.type == 'lintroller-refill')) {
      swatches[0].style.display = 'none';
    }
    
    // Always show the swatch element if we have any swatches
    if (displayedSwatchCount > 0) {
      swatchEle.style.display = 'flex';
    } else {
      swatchEle.style.display = 'none';
    }
    
    // Create ordered array for swatch list (ALL swatches including clubbed products)
    const orderedSwatchesForList = completeOrderedList.map((item, index) => {
      const isClubbed = nonSaleClubbedProducts.includes(item) || saleClubbedProducts.includes(item);
      // Check if this item is displayed in nav (only regular swatches can be displayed)
      const isDisplayedInNav = !isClubbed && navDisplayList.indexOf(item) < MAX_DISPLAYED_SWATCHES;
      return Object.assign({}, item, {
        is_displayed_in_nav: isDisplayedInNav,
        is_clubbed: isClubbed
      });
    });
    
    // Update the swatch list component
    const swatchList = this.querySelector('product-swatch-list');
    if (swatchList) {
      if (totalSwatches > 0) {
        swatchList.orderedSwatches = orderedSwatchesForList;
        swatchList.currentStyle = this.style;
        swatchList.style.display = 'block';
      } else {
        swatchList.style.display = 'none';
      }
    }
    
    
    this.initSwatchClick();
  }


  updateSwatchStore(swatches){
  this.swatchStore = {};
    for (const swatch of swatches) {
      if (!this.swatchStore[swatch.shop_url]) {
        this.swatchStore[swatch.shop_url] = {
          url_slug: swatch.url_slug,
          group: swatch.group
        };
      }
    }
  }
  //Render swatches for a product type like unit or tee
  async renderSwatches() {
    const packsIncluded = this.getAttribute('renderPack') == "True" || this.getAttribute('renderPack') == true;

    if(!packsIncluded){
        this.renderGroupSwatches()
      }
      else{
        this.renderPackSwatches()
      }
  }

}
window.customElements.define('product-nav', ProductNav);
